import * as React from "react";
import { Typography, Box } from "@mui/material";
import { ResponsiveContainer } from "@/components/dashboard/ResponsiveContainer";
import { InformationGrid } from "@/components/dashboard/InformationGrid";
import { ApplicationSection } from "@/components/system/sections/ApplicationSection";
import { HealthSection } from "@/components/system/sections/HealthSection";
import { ProductionSection } from "@/components/system/sections/ProductionSection";

export function SystemPage(): React.JSX.Element {
  return (
    <ResponsiveContainer>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          System
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Backend-reported system health and readiness only.
        </Typography>
      </Box>
      <InformationGrid>
        <ApplicationSection />
        <HealthSection />
        <ProductionSection />
      </InformationGrid>
    </ResponsiveContainer>
  );
}
